import React from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  selectPages,
  selectMetadata,
  setMetadata,
  setSchools,
} from "../redux/reportSlice";
import SelectFilter from "./SelectFilter";

export default function FilterPanel() {
  const metadata = useSelector(selectMetadata);
  const filters = metadata && metadata.filters ? metadata.filters : [];
  const filterMarkup = filters.map((filter, index) => {
    const {
      options,
      optionsDataSource,
      optionValueProperty,
      optionLabelProperty,
      isMulti,
      name,
      label,
    } = filter;
    return (
      <SelectFilter
        key={index}
        options={options}
        optionsDataSource={optionsDataSource}
        optionValueProperty={optionValueProperty}
        optionLabelProperty={optionLabelProperty}
        isMulti={isMulti}
        name={name}
        label={label}
      ></SelectFilter>
    );
  });
  return <React.Fragment>{filterMarkup}</React.Fragment>;
}
